"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ContactService.$inject = ['api'];
function ContactService(api) {
}
exports.ContactService = ContactService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/contact/services/contact.js
// module id = 450
// module chunks = 0